import { useMap } from 'react-leaflet/hooks';
import React, { useEffect } from 'react';
import { splashStillUp } from './MyMap.js';
import Web3 from 'web3';
import { IoCopyOutline, IoOpenOutline } from 'react-icons/io5';
import { FiDownload } from 'react-icons/fi';
import contract from './redux/config/config.json';
import { isAndroid, isIOS } from 'react-device-detect';
import polygonJson from '../data/geo_json_string.json';
import { useDispatch, useSelector } from 'react-redux';
import { fetchData } from './redux/data/dataActions';
import { useState, useRef } from 'react';

import '../styles/mintmessages.css';
import DetectDevice from './DeviceDetector.js';

var contractAddress;

if (contract.NETWORK.ID == 1) {
  contractAddress = String(contract.CONTRACT_ADDRESS);
}
if (contract.NETWORK.ID == 5) {
  contractAddress = String(contract.CONTRACT_ADDRESS_GOERLI);
}

const MintMessages = ({
  mintMessage,
  setMintMessage,
  masterTile,
  revertMessage,
  setRevertMessage,
  physicalClaimed,
  setphysicalClaimed,
}) => {
  const map = useMap();
  const currentTile = masterTile.masterTile;
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const [selectedStatus, setSelectedStatus] = useState('All');
  const [reviewForm, setReviewForm] = useState(0);

  function cancelmint({}) {
    var mint = document.getElementById('mint-screen');
    mint.style.animation = 'fadeOut .35s';
    console.log(mint.style.animation);
    var projTitle = document.getElementsByClassName('project-title')[0];
    projTitle.style.visibility = 'visible';
    projTitle.style.animation = 'fadeIn 1.5s';
    map.dragging.enable();
    map.touchZoom.enable();
    setTimeout(clearmint, 340);
  }

  function clearmint() {
    var mint = document.getElementById('mint-screen');
    mint.style.display = 'none';
  }

  function getPackage(currentTile) {
    let package1 =
      polygonJson.features[0].features[parseInt(getNum(currentTile.name))]
        .features[0].properties.collector_package;
    return package1;
  }

  function getNum(numString) {
    let num = numString.split('-')[1];
    return num;
  }

  function setEthScanLink(txHash) {
    var link_base = '';
    if (contract.NETWORK.ID == 1) {
      link_base = 'https://etherscan.io/tx/';
    }
    if (contract.NETWORK.ID == 5) {
      link_base = 'https://goerli.etherscan.io/tx/';
    }
    let full_link = link_base.concat(txHash);
    return full_link;
  }

  function setOpenseaLink(curTile) {
    var link_base = '';
    if (contract.NETWORK.ID == 1) {
      link_base = 'https://opensea.io/assets/ethereum/';
    }
    if (contract.NETWORK.ID == 5) {
      link_base = 'https://testnets.opensea.io/assets/goerli/';
    }
    let link_with_contract = link_base.concat(String(contractAddress));
    let link2 = link_with_contract.concat('/');
    let full_link = link2.concat(curTile);
    return full_link;
  }

  function setTODEMLink(curTile) {
    const link_base = 'https://latentculture.com/todem/';
    let full_link = link_base.concat(getNum(curTile));
    return full_link;
  }

  function copyTODEMLink(curTile) {
    const link_base = 'https://latentculture.com/todem/';
    let full_link = link_base.concat(getNum(curTile));
    navigator.clipboard.writeText(full_link);
    //alert("Copied: " + full_link);
  }
  function saveFormData(tile) {
      var name = document.getElementById('name').value;
      var email = document.getElementById('email').value;
      var address2 = document.getElementById('address1').value;
      var address1 = document.getElementById('address2').value;
      var city = document.getElementById('city').value;
      var state = document.getElementById('state').value;
      var country = document.getElementById('country').value;
      var zip = document.getElementById('zip').value;
      var frame = selectedStatus;

      //event.preventDefault();
      var formData = {
          name: name,
          email: email,
          address1: address1,
          address2: address2,
          city: city,
          state: state,
          country: country,
          zip: zip,
          wallet: blockchain.account,
          tile: tile,
          frame: frame
      };
      console.log(formData)
      //fetch('https://www.latentculture.com/record-affiliate', 
      //http://localhost:3001/save-form-data
      fetch('https://www.latentculture.com/save-form-data', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
      })
      .then(response => response.text())
      .then(message => {
        if(message == "Form data saved successfully!"){}
          setMintMessage("physical_claimed");
          //setphysicalClaimed(true);
          console.log(message)
      })
      .catch(error => {
          console.error(error);
          setMintMessage("Error submitting form");
      });
  }

  function handleSubmit(){
    if(reviewForm == 1){
      saveFormData(getNum(currentTile.name))
      setReviewForm(2)
    }
    else if(reviewForm == 0){
      setReviewForm(1)
    }
  }
  //console.log(reviewForm)
  //setReviewForm(0);
  useEffect(() => {
    if (mintMessage == null) {
      if (!splashStillUp) {
        map.dragging.enable();
        map.touchZoom.enable();
      }
    } else {
      map.dragging.disable();
      map.touchZoom.disable();
    }

    if (mintMessage != null && typeof mintMessage.message != null) {
      if (
        mintMessage.message ==
        'MetaMask Tx Signature: User denied transaction signature.'
      ) {
        setMintMessage(null);
      }
    }
  }, [mintMessage]);
  if (mintMessage == null) {
    return <></>;
  } else {
    return (
      <div id="mint-screen">
        {mintMessage != 'minting' ? (
          <div
            id="mint-background"
            onClick={() => {
              cancelmint({});
              setMintMessage(null);
            }}
          ></div>
        ) : null}

        {mintMessage == 'minting' ? (
          <div id="mint-info">
            <br />
            <br />
            <div id="mint-title">minting in progress</div>
            <div className="animated-background"></div>
            <div className="mint-content">
              <p style={{ color: '#000000' }}>please remain on this page</p>
            </div>
            {/*}

                    <div className="mint-footer">
                        <button id="mint-cancel" onClick={() => { cancelmint({}); setMintMessage(null) }}>cancel</button>
                    </div>

                    */}
          </div>
        ) : null}

        {mintMessage == 'claimingTPX' ? (
          <div id="mint-info">
            <br />
            <br />
            <div id="mint-title">claim in progress</div>
            <div className="animated-background"></div>
            <div className="mint-content">
              <p style={{ color: '#000000' }}>please remain on this page</p>
            </div>
            {/*}

                    <div className="mint-footer">
                        <button id="mint-cancel" onClick={() => { cancelmint({}); setMintMessage(null) }}>cancel</button>
                    </div>

                    */}
          </div>
        ) : null}

        {mintMessage == 'claimedTPX' ? (
         <div
            id="mint-info-claim"
            style={{ backgroundColor: '#ffcc33aa'}}
          >
            <div
              id="mint-title"
              style={{ fontFamily: 'Terminus', color: '#000000', marginTop: "55px" }}
            >
              Claimed!
            </div>

            <div
              className="mint-content"
              style={{ color: 'rgb(0, 0, 0)', marginLeft: 0, marginRight: 0, marginTop: "5px", fontSize: "30px"}}
            >
              <p>
                {revertMessage} TPX
                <br></br>
                <span style={{ color: '#222244', fontSize: "16px" }}>
                  a glorious future awaits
                </span>
                <br></br>
              </p>
            </div>
          </div>
        ) : null}

        {mintMessage == 'claimed' ? (
          <div
            id="mint-info-claim"
            style={{ backgroundColor: '#ffcc33aa'}}
          >
            <div
              id="mint-title"
              style={{ fontFamily: 'Terminus', color: '#000000', marginTop: "0.3em" }}
            >
              Welcome to TODEM
            </div>

            <div
              className="mint-content"
              style={{ color: 'rgb(0, 0, 0)', marginLeft: 0, marginRight: 0 }}
            >
              <p>
                <span style={{ color: '#222244' }}>
                  You're now the proud owner of
                </span>
                <br></br>
                <br></br>
                <h5> TODEM Tile #{getNum(currentTile.name)}</h5>
                <br></br>
                <span style={{ color: '#222244' }}>
                  Copy Your Tile Link
                </span>{' '}
                <spacer> </spacer>
                <a
                  onClick={() => {
                    copyTODEMLink(currentTile.name);
                    var copy = document.getElementById('feedback-container');
                    if (copy) {
                      copy.style.display = 'block';
                      copy.style.zindex = '3000';
                      copy.style.animation = 'fadeIn 1s';
                      setTimeout(() => {
                        copy.style.animation = 'fadeOut 1s';
                        setTimeout(() => {
                          copy.style.display = 'none';
                        }, 1000);
                      }, 3000);
                    }
                  }}
                  style={{ fontSize: '18', cursor: 'pointer' }}
                >
                  <IoCopyOutline className="icon" id="close-icon" />
                </a>
                <br />
                <span style={{ color: '#222244' }}>
                  Download Collector Package
                </span>{' '}
                <spacer> </spacer>
                <a
                  href={getPackage(currentTile)}
                  style={{ textDecoration: 'none', color: '#000000' }}
                >
                  <FiDownload className="icon" id="download-icon" />
                </a>
                {/*}
                            <a href={getPackage(currentTile)} style={{textDecoration: "none", color: "#000000"}}>
                                TODEM.collector_package.{getNum(currentTile.name)}.zip
                            </a> 
                            */}
              </p>
            </div>
          </div>
        ) : null}

        {(mintMessage == 'claim_physical' || mintMessage == 'physical_claimed') ? (
          <div
            id="mint-info"
            style={{marginTop:"3%", width: "100%", maxWidth: "750px", height: "90%", maxHeight: "700px", background: "#FEBE32", border: "3px solid #000000", borderRadius: "15px"}}
          >
            <div
              id="mint-title"
              style={{ fontFamily: "Terminus", color: "#000000", fontStyle: "normal", fontSize: "38px", fontWeight: "500", lineHeight: "40px", letterSpacing: "-0.015em", textAlign: "center", color: "#000000", marginTop: "20px" }}
            >
              TODEM Class {parseInt(getNum(currentTile.name)) <= 9 ? "A" : "B"} Physical
            </div>
            <div id="mint-title" 
            style={{
              paddingRight: "6%",
              paddingLeft: "6%",
              fontFamily: "AndaleMono",
              fontStyle: "normal",
              fontWeight: "400",
              fontSize: "16px",
              lineHeight: "24px",
              textAlign: "center",
              letterSpacing: "-0.1em",
              color: "#000000"}}
              >
              {reviewForm==0 ? (
              <>
              As the owner of a Class {parseInt(getNum(currentTile.name)) <= 9 ? "A" : "B"} Tile, you're entitled to
              {parseInt(getNum(currentTile.name)) <= 9 ? 
              <> a custom display & animation of your Tile as well as a signed 25" (long side) print. Please complete the information below and we’ll ship the print and display.</>: 
              <> a signed 25" (long side) print. Please complete the information below and we’ll ship the print.</>}
              </>
              ): reviewForm==1 ? <span style={{fontSize:"24px"}}> Review information </span> : null}
              <div className="info-line-container">
              <span className="info-line-message"></span>
            </div>          
            </div>            
            <div
              className="mint-content-claim" 
              style={{ textAlign: "left", color: 'rgb(0, 0, 0)', marginLeft: 0, marginRight: 0, marginTop: "5px", height: "fit-content" }}
            >
            {(mintMessage == 'claim_physical' && reviewForm !== 2) ? (
            <div style={{height:"fit-content", width:"75%"}}>
            {reviewForm==0 ? (
            <>
            <h5 style={{letterSpacing: "-0.03em", fontSize:"17px", fontWeight: "700", marginBottom:"5px", textAlign:"left"}}>Which animation frame would you like printed?</h5>
              <div className="form-grid-container-header" style={{textAlign: "left"}}>
                <div className="form-grid-item-header">
                <label>
                  <img style={{width:"auto", height: "90px", marginTop:"10px"}} src={"https://www.latentculture.com/tohm/thumbs/thumbnails-384-OnlyAB/thumbnail-384-frame0/"+currentTile.name+".jpg"}></img>
                  <br></br>
                    Frame 0
                    <br></br>
                    <input
                      type="radio"
                      value="Frame0"
                      autoComplete="off"
                      checked={selectedStatus === 'Frame0'}
                      onChange={(e) => setSelectedStatus(e.target.value)}
                    />
                  </label>
                </div>
                <div className="form-grid-item-header">
                <label>
                  <img style={{width:"auto", height: "90px", marginTop:"10px"}} src={"https://www.latentculture.com/tohm/thumbs/thumbnails-384-OnlyAB/thumbnail-384-frame17/"+currentTile.name+".jpg"}></img>
                  <br></br>
                    Frame 17   
                    <br></br>               
                    <input
                      type="radio"
                      value="Frame17"
                      autoComplete="off"
                      checked={selectedStatus === 'Frame17'}
                      onChange={(e) => setSelectedStatus(e.target.value)}
                    />
                  </label>
                </div>
                <div className="form-grid-item-header">
                  <label>
                  <img style={{width:"auto", height: "90px", marginTop:"10px"}} src={"https://www.latentculture.com/tohm/thumbs/thumbnails-384-OnlyAB/thumbnail-384-frame25/"+currentTile.name+".jpg"}></img>
                  <br></br>                  
                    Frame 25
                    <br></br>
                    <input
                      type="radio"
                      value="Frame25"
                      autoComplete="off"
                      checked={selectedStatus === 'Frame25'}
                      onChange={(e) => setSelectedStatus(e.target.value)}
                    />
                  </label>
                </div>
                <div className="form-grid-item-header">
                <label>
                  <img style={{width:"auto", height: "90px", marginTop:"10px"}} src={"https://www.latentculture.com/tohm/thumbs/thumbnails-384-OnlyAB/thumbnail-384-frame33/"+currentTile.name+".jpg"}></img>
                  <br></br>
                    Frame 33
                    <br></br>
                    <input
                      type="radio"
                      value="Frame33"
                      autoComplete="off"
                      checked={selectedStatus === 'Frame33'}
                      onChange={(e) => setSelectedStatus(e.target.value)}
                    />
                  </label>
                </div>
                <div className="form-grid-item-header">
                  <label>
                  <img style={{width:"auto", height: "90px", marginTop:"10px"}} src={"https://www.latentculture.com/tohm/thumbs/thumbnails-384-OnlyAB/thumbnail-384-frame67/"+currentTile.name+".jpg"}></img>
                  <br></br>
                    Frame 67 
                    <br></br>                
                    <input
                      type="radio"
                      value="Frame67"
                      autoComplete="off"
                      checked={selectedStatus === 'Frame67'}
                      onChange={(e) => setSelectedStatus(e.target.value)}
                    />
                  </label>
                </div>
              </div>   
              </>) : (
           <>
            <h5 style={{letterSpacing: "-0.03em", fontSize:"17px", fontWeight: "700", marginBottom:"5px", textAlign:"center"}}>Frame selected:</h5>
              <div className="form-grid-container-header" style={{textAlign: "left"}}>
                <div className="form-grid-item-header"></div>
                <div className="form-grid-item-header"></div>
                <div className="form-grid-item-header">
                  <img style={{width:"auto", height: "175px", marginTop:"10px"}} src={"https://www.latentculture.com/tohm/thumbs/thumbnails-384-OnlyAB/thumbnail-384-" + selectedStatus.toLowerCase() + "/" + currentTile.name + ".jpg"}></img>
                  <br></br>
                  <label>
                    {selectedStatus.replace(/(\D)(\d)/, "$1 $2")}
                  </label>
                </div>
                <div className="form-grid-item-header"></div>
                <div className="form-grid-item-header"></div>
              </div>   
              </>
              )}
              {reviewForm==0 ? (
              <>
              <h5 style={{marginTop:"10px", letterSpacing: "-0.03em", fontSize:"17px", fontWeight: "700"}}>Shipping Information</h5>
              <div className="form-grid-container">
                <div className="form-grid-item">
                <label for="name">Full Name</label>
                <br></br>
                <input type="text" 
                style={{boxSizing: "border-box",
                      background: "#FFE2A2",
                      border: "1px solid #000000",
                      borderRadius: "4px",
                      width: "93%"
                      }}
                id="name" name="name" required />
                </div>
                <div className="form-grid-item">
                <label for="email">Email</label>
                <br></br>
                <input type="email"
                style={{boxSizing: "border-box",
                      background: "#FFE2A2",
                      border: "1px solid #000000",
                      borderRadius: "4px",
                      width: "93%"
                      }}
                id="email" name="email" required />
                </div>
                <div className="form-grid-item">
                <label for="address1">Street Address</label>
                <br></br>
                <input type="text"
                style={{boxSizing: "border-box",
                      background: "#FFE2A2",
                      border: "1px solid #000000",
                      borderRadius: "4px",
                      width: "93%"
                      }}
                 id="address1" name="address1" required />
                </div> 
                <div className="form-grid-item">      
                <label for="address2">Apt. Suite. etc.</label>
                <br></br>
                <input type="text" 
                style={{boxSizing: "border-box",
                      background: "#FFE2A2",
                      border: "1px solid #000000",
                      borderRadius: "4px",
                      width: "93%"
                      }}
                      id="address2" name="address2" required />
                </div>
                <div className="form-grid-item">      
                <label for="city">City</label>
                <br></br>
                <input type="text" 
                style={{boxSizing: "border-box",
                      background: "#FFE2A2",
                      border: "1px solid #000000",
                      borderRadius: "4px",
                      width: "93%"
                      }}
                      id="city" name="city" required />
                </div>              
                <div className="form-grid-item">      
                <label for="state">State/Province</label>
                <br></br>
                <input type="text" 
                style={{boxSizing: "border-box",
                      background: "#FFE2A2",
                      border: "1px solid #000000",
                      borderRadius: "4px",
                      width: "93%"
                      }}
                      id="state" name="state" required />
                </div>  
                <div className="form-grid-item">      
                <label for="country">Country</label>
                <br></br>
                <input type="text" 
                style={{boxSizing: "border-box",
                      background: "#FFE2A2",
                      border: "1px solid #000000",
                      borderRadius: "4px",
                      width: "93%"
                      }}
                      id="country" name="country" required />
                </div> 
                <div className="form-grid-item">      
                <label for="zip">Zip/Postal</label>
                <br></br>
                <input type="text" 
                style={{boxSizing: "border-box",
                      background: "#FFE2A2",
                      border: "1px solid #000000",
                      borderRadius: "4px",
                      width: "93%"
                      }}
                      id="zip" name="zip" required />
                </div>  
              </div>
              </>) : (
              <>
              <h5 style={{letterSpacing: "-0.03em", fontSize:"17px", fontWeight: "700"}}>Shipping Information</h5>
              <div className="form-grid-container">
                <div className="form-grid-item">
                <label for="name">Full Name</label>
                <br></br>
                <input type="text" 
                style={{boxSizing: "border-box",
                      background: "rgba(255, 255, 255, 0.8)",
                      border: "0px solid #000000",
                      borderRadius: "4px",
                      width: "93%"
                      }}
                id="name" name="name" disabled />
                </div>
                <div className="form-grid-item">
                <label for="email">Email</label>
                <br></br>
                <input type="email"
                style={{boxSizing: "border-box",
                      background: "rgba(255, 255, 255, 0.8)",
                      border: "0px solid #000000",
                      borderRadius: "4px",
                      width: "93%"
                      }}
                id="email" name="email" disabled />
                </div>
                <div className="form-grid-item">
                <label for="address1">Street Address</label>
                <br></br>
                <input type="text"
                style={{boxSizing: "border-box",
                      background: "rgba(255, 255, 255, 0.8)",
                      border: "0px solid #000000",
                      borderRadius: "4px",
                      width: "93%"
                      }}
                 id="address1" name="address1" disabled />
                </div> 
                <div className="form-grid-item">      
                <label for="address2">Apt. Suite. etc.</label>
                <br></br>
                <input type="text" 
                style={{boxSizing: "border-box",
                      background: "rgba(255, 255, 255, 0.8)",
                      border: "0px solid #000000",
                      borderRadius: "4px",
                      width: "93%"
                      }}
                      id="address2" name="address2" disabled />
                </div>
                <div className="form-grid-item">      
                <label for="city">City</label>
                <br></br>
                <input type="text" 
                style={{boxSizing: "border-box",
                      background: "rgba(255, 255, 255, 0.8)",
                      border: "0px solid #000000",
                      borderRadius: "4px",
                      width: "93%"
                      }}
                      id="city" name="city" disabled />
                </div>              
                <div className="form-grid-item">      
                <label for="state">State/Province</label>
                <br></br>
                <input type="text" 
                style={{boxSizing: "border-box",
                      background: "rgba(255, 255, 255, 0.8)",
                      border: "0px solid #000000",
                      borderRadius: "4px",
                      width: "93%"
                      }}
                      id="state" name="state" disabled />
                </div>  
                <div className="form-grid-item">      
                <label for="country">Country</label>
                <br></br>
                <input type="text" 
                style={{boxSizing: "border-box",
                      background: "rgba(255, 255, 255, 0.8)",
                      border: "0px solid #000000",
                      borderRadius: "4px",
                      width: "93%"
                      }}
                      id="country" name="country" disabled />
                </div> 
                <div className="form-grid-item">      
                <label for="zip">Zip/Postal</label>
                <br></br>
                <input type="text" 
                style={{boxSizing: "border-box",
                      background: "rgba(255, 255, 255, 0.8)",
                      border: "0px solid #000000",
                      borderRadius: "4px",
                      width: "93%"
                      }}
                      id="zip" name="zip" disabled />
                </div>  
              </div>
              </>
              )}

              {reviewForm == 1 ?
                (
                <>
                <input type="Edit" 
                style={{fontFamily: "Terminus", cursor:"pointer", letterSpacing:"0.005em", fontStyle:"normal", fontWeight:"700",
                border: "1px solid #000000", "border-radius": "10px", background: "#FFECC1", width: "60px", height: "30px",
                justifyContent: "center", fontSize:"18", textAlign: "center", marginLeft:"0%", marginTop: "20px"}} 
                value="Edit" onClick={() => setReviewForm(0)}/>

                <input type="Submit" 
                style={{fontFamily: "Terminus", cursor:"pointer", letterSpacing:"0.005em", fontStyle:"normal", fontWeight:"700",
                border: "1px solid #000000", "border-radius": "10px", background: "#FFECC1", width: "100px", height: "30px",
                justifyContent: "center", fontSize:"18", textAlign: "center", marginTop: "20px", marginLeft:"29%"}} 
                value="Submit" onClick={() => handleSubmit()}/>  
                </> 
                ) : 
                (
                <input type="Continue" 
                style={{fontFamily: "Terminus", cursor:"pointer", letterSpacing:"0.005em", fontStyle:"normal", fontWeight:"700",
                border: "1px solid #000000", "border-radius": "10px", background: "#FFECC1", width: "100px", height: "30px",
                justifyContent: "center", fontSize:"18", textAlign: "center", marginTop: "20px", marginLeft:"40%"}} 
                value="Continue" onClick={() => handleSubmit()}/>  
                )
              }

            {/*<input type="submit" value="Save">*/}
            </div>
            ) : 
            <div style={{height:"372px", width: "606px", textAlign:"center", paddingTop:"210px", fontSize: "20px"}}> <span style={{fontFamily: "Terminus", fontSize: "40px", color: "#B52B00"}}>Physical Claimed! </span><br></br> <br></br> We'll send shipping details to the email address provided.</div>}           
            </div>
            {reviewForm == 2 ?
            <input type="Done"
              style={{fontFamily: "Terminus", cursor:"pointer", letterSpacing:"0.005em", fontStyle:"normal", fontWeight:"700",
              border: "1px solid #000000", "border-radius": "10px", background: "#FFECC1", width: "100px", height: "30px",
              justifyContent: "center", fontSize:"18px", textAlign: "center", marginTop: "20%"}} 
              value="Close"
              onClick={() => {
                setReviewForm(0);
                setMintMessage(null);
              }}
            />
            : null }
            {reviewForm !== 2 ?
              (
              <>
              <div id="mint-title" 
              style={{
                paddingRight: "6%",
                paddingLeft: "6%",
                fontFamily: "AndaleMono",
                fontStyle: "normal",
                fontWeight: "400",
                fontSize: "13px",
                lineHeight: "24px",
                textAlign: "center",
                letterSpacing: "-0.12em",
                bottom: "10px",
                width:"100%",
                position:"absolute",
                color: "#000000"}}
                >
                <div className="info-line-container">
                  <span className="info-line-message"></span>
                </div>
                *Only one claim per Class A/B Tile will be honored.</div>
            </>
          ) : null}
          </div>
        ) : null}

        {mintMessage != 'claimed' &&
        mintMessage != 'minting' &&
        mintMessage != null &&
        mintMessage != 'no_wallet' &&
        mintMessage != 'claimingTPX' &&
        mintMessage != 'claimedTPX' ? (
          <div
            id="mint-info"
            style={{
              backgroundColor: '#000000aa',
              borderColor: '#cc3333aa',
            }}
          >
            <div id="mint-title" style={{ color: '#cc3333aa' }}>
              error
            </div>
            <div className="mint-content" style={{ color: '#cc3333aa' }}>
              <p>
                We're sorry, something went wrong.
                <br />
                We received the following message:
                <br />
                <br />
                {mintMessage != 'over_limit' && mintMessage != 'no_wallet' ? (
                  <>
                    <a
                      style={{ color: '#cc3333aa' }}
                      href={setEthScanLink(mintMessage)}
                    >
                      {' '}
                      {revertMessage}{' '}
                    </a>
                  </>
                ) : (
                  <>{revertMessage}</>
                )}
              </p>
            </div>
          </div>
        ) : null}
        {mintMessage == 'no_wallet' ? (
          <div
            id="mint-info"
            style={
              DetectDevice
                ? {
                    height: 'fit-content',
                    backgroundColor: '#1a1830a8',
                    borderColor: '#abababe6',
                    marginTop: '50%',
                  }
                : {
                    backgroundColor: '#1a1830a8',
                    borderColor: '#ffffffa8',
                  }
            }
          >
            {DetectDevice ? (
              <div
                id="mint-box"
                style={{
                  height: 'fit-content',
                }}
              >
                <div
                  className="mint-content"
                  style={{
                    height: DetectDevice ? 'fit-content' : 'unset',
                    marginBottom: DetectDevice ? '5px' : 'unset',
                    color: 'white',
                  }}
                  onClick={() => {
                    console.log(mintMessage);
                  }}
                >
                  <p>Minting is currently only available on desktop.</p>
                </div>
              </div>
            ) : (
              <div className="mint-content" style={{ color: '#bebebe' }}>
                <p>
                  Connect your Ethereum wallet via the
                  <br />
                  'Connect' button in the top right.
                  <br />
                  <br />
                  If you don't have an Ethereum wallet, visit
                  <br /> our minting guide for more information
                  <br />
                </p>
              </div>
            )}

            <div
              className="close-button"
              style={
                DetectDevice
                  ? {
                      position: 'unset',
                      color: '#bebebe',
                      marginTop: '3px',
                      paddingRight: '4.5vw',
                      width: 'fit-content',
                    }
                  : { color: '#bebebe' }
              }
              onClick={() => {
                cancelmint({});
                setMintMessage(null);
                var playbox = document.getElementsByClassName(
                  'bttn frame-controller'
                )[0];
                playbox.style.visibility = 'visible';
              }}
            >
              ok
            </div>
          </div>
        ) : null}
      </div>
    );
  }
};

export default MintMessages;
